var _rect, _rect2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    fill: "#F0F1FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 3.5,
    stroke: "#DFDEFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_24593_9016)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9986 21.01V15C19.9986 14.45 19.5486 14 18.9986 14C18.4486 14 17.9986 14.45 17.9986 15V21.01H16.2086C15.7586 21.01 15.5386 21.55 15.8586 21.86L18.6486 24.64C18.8486 24.83 19.1586 24.83 19.3586 24.64L22.1486 21.86C22.4686 21.55 22.2386 21.01 21.7986 21.01H19.9986ZM12.6486 7.35002L9.85857 10.14C9.53857 10.45 9.75857 10.99 10.2086 10.99H11.9986V17C11.9986 17.55 12.4486 18 12.9986 18C13.5486 18 13.9986 17.55 13.9986 17V10.99H15.7886C16.2386 10.99 16.4586 10.45 16.1386 10.14L13.3486 7.35002C13.1586 7.16002 12.8386 7.16002 12.6486 7.35002Z",
    fill: "#202652"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_24593_9016"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/sort-icon.7699d1ce.svg";
export { ForwardRef as ReactComponent };